import {
  isEmpty,
  every,
  some,
  isEqual,
  isString,
  isNull,
  isArray,
  includes,
  isObject,
  has,
  orderBy,
  endsWith,
  get,
  forEach
} from "lodash-es";
export function filterLocalEntitiesToHasura(records, { where, order_by, limit, offset, isInfinite } = {}) {
  let filteredRecords = [...records];
  if (where) {
    filteredRecords = applyWhereClause(filteredRecords, where);
  }
  if (order_by) {
    filteredRecords = applyOrderBy(filteredRecords, order_by);
  }
  filteredRecords = restoreEntitiesFromLocalFilter(filteredRecords);
  const allFilteredRecords = [...filteredRecords];
  if (!isInfinite && offset !== void 0) {
    filteredRecords = filteredRecords.slice(offset);
  }
  if (!isInfinite && limit !== void 0) {
    filteredRecords = filteredRecords.slice(0, limit);
  }
  return {
    entities: filteredRecords,
    entitiesAcrossPages: allFilteredRecords,
    entityCount: allFilteredRecords.length
  };
}
function applyWhereClause(records, where) {
  function applyFilter(record, filter) {
    if (isEmpty(filter)) {
      return true;
    }
    for (const key in filter) {
      if (key === "_and") {
        if (isEmpty(filter[key])) {
          continue;
        }
        if (!every(filter[key], (subFilter) => applyFilter(record, subFilter))) {
          return false;
        }
      } else if (key === "_or") {
        if (isEmpty(filter[key])) {
          continue;
        }
        if (!some(filter[key], (subFilter) => applyFilter(record, subFilter))) {
          return false;
        }
      } else if (key === "_not") {
        if (applyFilter(record, filter[key])) {
          return false;
        }
      } else {
        const value = get(record, key);
        const conditions = filter[key];
        if (isObject(value) && isObject(conditions) && !hasOperator(conditions)) {
          return applyFilter(value, conditions);
        }
        for (const operator in conditions) {
          const conditionValue = conditions[operator];
          if (operator === "_gt" && conditions._lt) {
            if (!(value > conditionValue && value < conditions._lt))
              return false;
            continue;
          }
          if (operator === "_gte" && conditions._lte) {
            if (!(value >= conditionValue && value <= conditions._lte))
              return false;
            continue;
          }
          switch (operator) {
            case "_eq":
              if (!isEqual(value, conditionValue)) return false;
              break;
            case "_neq":
              if (isEqual(value, conditionValue)) return false;
              break;
            case "_gt":
              if (!(value > conditionValue)) return false;
              break;
            case "_gte":
              if (!(value >= conditionValue)) return false;
              break;
            case "_lt":
              if (!(value < conditionValue)) return false;
              break;
            case "_lte":
              if (!(value <= conditionValue)) return false;
              break;
            case "_like":
              if (!isString(value) || !new RegExp(conditionValue.replace(/%/g, ".*")).test(value))
                return false;
              break;
            case "_ilike":
              if (!isString(value) || !new RegExp(conditionValue.replace(/%/g, ".*"), "i").test(value))
                return false;
              break;
            case "_nlike":
              if (!isString(value) || new RegExp(conditionValue.replace(/%/g, ".*")).test(value))
                return false;
              break;
            case "_nilike":
              if (!isString(value) || new RegExp(conditionValue.replace(/%/g, ".*"), "i").test(value))
                return false;
              break;
            case "_starts_with":
              if (!isString(value) || !value.startsWith(conditionValue))
                return false;
              break;
            case "_ends_with":
              if (!isString(value) || !value.endsWith(conditionValue))
                return false;
              break;
            case "_is_null":
              if (conditionValue && !isNull(value) || !conditionValue && isNull(value))
                return false;
              break;
            case "_contains":
              if (!isArray(value) || !every(conditionValue, (item) => includes(value, item)))
                return false;
              break;
            case "_contained_in":
              if (!isArray(value) || !every(value, (item) => includes(conditionValue, item)))
                return false;
              break;
            case "_has_key":
              if (!isObject(value) || !has(value, conditionValue)) return false;
              break;
            case "_has_keys_any":
              if (!isObject(value) || !some(conditionValue, (item) => has(value, item)))
                return false;
              break;
            case "_has_keys_all":
              if (!isObject(value) || !every(conditionValue, (item) => has(value, item)))
                return false;
              break;
            case "_similar":
              if (!isString(value) || !new RegExp(conditionValue.replace(/%/g, ".*")).test(value))
                return false;
              break;
            default:
              if (operator.startsWith("_")) {
                console.warn(`Unsupported operator: ${operator}`);
                return false;
              } else {
                console.warn(`Unsupported operator: ${operator}`);
                return false;
              }
          }
        }
      }
    }
    return true;
  }
  function hasOperator(obj) {
    return Object.keys(obj).some((key) => key.startsWith("_"));
  }
  return records.filter((record) => applyFilter(record, where));
}
function applyOrderBy(records, _order_by) {
  const order_by = isArray(_order_by) ? _order_by : isEmpty(_order_by) ? [] : [_order_by];
  if (order_by.length > 0) {
    const orderFuncs = [];
    const ascOrDescArray = [];
    order_by.forEach(
      ({ path, direction, type, sortFn, getValueToFilterOn, ownProps }) => {
        direction = direction || "desc";
        if (sortFn) {
          const sortFnArray = Array.isArray(sortFn) ? sortFn : [sortFn];
          sortFnArray.forEach((fn) => {
            const getter = typeof fn === "function" ? fn : (r) => get(r, fn);
            orderFuncs.push((r) => {
              const val = getter(r);
              return val !== null && val !== void 0 ? 1 : 0;
            });
            ascOrDescArray.push("desc");
            orderFuncs.push(getter);
            ascOrDescArray.push(direction);
          });
        } else if (getValueToFilterOn) {
          orderFuncs.push((r) => {
            const val = getValueToFilterOn(r, ownProps);
            return val !== null && val !== void 0 ? 1 : 0;
          });
          ascOrDescArray.push("desc");
          orderFuncs.push((r) => getValueToFilterOn(r, ownProps));
          ascOrDescArray.push(direction);
        } else if (type === "timestamp") {
          orderFuncs.push((r) => {
            const val = get(r, path);
            return val ? 1 : 0;
          });
          ascOrDescArray.push("desc");
          orderFuncs.push((r) => {
            const val = get(r, path);
            return val ? new Date(val).getTime() : -Infinity;
          });
          ascOrDescArray.push(direction);
        } else if (path && endsWith(path.toLowerCase(), "id")) {
          orderFuncs.push((r) => {
            const val = get(r, path);
            return val !== null && val !== void 0 ? 1 : 0;
          });
          ascOrDescArray.push("desc");
          orderFuncs.push((o) => {
            const val = get(o, path);
            if (val === null || val === void 0) return -Infinity;
            return parseInt(val, 10) || 0;
          });
          ascOrDescArray.push(direction);
        } else {
          orderFuncs.push((r) => {
            const val = get(r, path);
            return val !== null && val !== void 0 ? 1 : 0;
          });
          ascOrDescArray.push("desc");
          orderFuncs.push((r) => {
            const val = get(r, path);
            if (val === null || val === void 0) return -Infinity;
            if (isString(val)) {
              return val.toLowerCase().replace(
                /(\d+)/g,
                (num) => (
                  // Pad numbers with leading zeros for proper natural sort
                  num.padStart(10, "0")
                )
              );
            }
            return val;
          });
          ascOrDescArray.push(direction);
        }
      }
    );
    records = orderBy(records, orderFuncs, ascOrDescArray);
  }
  return records;
}
function restoreEntitiesFromLocalFilter(ents) {
  return ents.map((entity) => {
    forEach(entity, (val, key) => {
      if (key.startsWith?.("___original___")) {
        entity[key.slice("___original___".length)] = val;
        delete entity[key];
      }
    });
    return entity;
  });
}
